import warehouse from './warehouse'

export default [
  ...warehouse,
]
